function sendNewsletter(event) {
  event.preventDefault(); 
  const form = event.target;
  const route = form.action;

  // Limpa erros anteriores de campos
  form.querySelectorAll('.form-group').forEach(group => group.classList.remove('has-error'));
  
  // Oculta mensagem de erro global e de sucesso anteriores
  const globalErrorMessage = document.getElementById('newsletter-error-message');
  const successMessage = document.getElementById('newsletter-success-message');
  const titleNewsletter = document.querySelector('.title-newsletter');
  if (globalErrorMessage) globalErrorMessage.classList.add('hidden');
  if (successMessage) successMessage.classList.add('hidden');

  // Captura os valores
  const nome = form.querySelector('[name="nome"]')?.value || '';
  const email = form.querySelector('[name="email"]')?.value || '';
  const telefone = form.querySelector('[name="telefone"]')?.value || '';

  let hasError = false;

  // Validação Nome: mínimo 3 letras, não pode ficar em branco
  if (nome.trim().length < 3) {
    form.querySelector('[name="nome"]').closest('.form-group').classList.add('has-error');
    hasError = true;
  }

  // Validação Email: padrão de email e não pode ficar em branco
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    form.querySelector('[name="email"]').closest('.form-group').classList.add('has-error');
    hasError = true;
  }

  // Validação Telefone: opcional e validação de telefone brasil
  if (telefone.trim() !== '') {
    const cleanPhone = telefone.replace(/\D/g, '');
    if (cleanPhone.length < 10 || cleanPhone.length > 11) {
      form.querySelector('[name="telefone"]').closest('.form-group').classList.add('has-error');
      hasError = true;
    }
  }

  if (hasError) {
    return;
  }

  // Prepara os dados em formato JSON para o servidor
  const payload = {
    name: nome,
    email: email,
    phone: telefone
  };

  // Manipulação visual do botão
  const submitButton = form.querySelector('button[type="submit"]');
  const buttonText = document.getElementById('footer-newsletter-button-text');
  const loadingSpinner = document.getElementById('footer-newsletter-loading');
  
  if (submitButton) {
    submitButton.disabled = true;
    submitButton.style.opacity = '0.7';
    if (buttonText) buttonText.classList.add('hidden');
    if (loadingSpinner) loadingSpinner.classList.remove('hidden');
  }

  // Envia os dados
  fetch(route, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify(payload)
  })
  .then(response => {
    if (response.ok) {
      // Oculta o formulário e mostra a mensagem de sucesso
      if (successMessage) {
        successMessage.classList.remove('hidden');
        form.style.display = 'none';
        if(titleNewsletter) {
          console.log(titleNewsletter, "<<<<<<<<<,")
          titleNewsletter.style.display = 'none';
        }
      }
      form.reset();
    } else {
      if (globalErrorMessage) globalErrorMessage.classList.remove('hidden');
    }
  })
  .catch(error => {
    console.error('Erro ao enviar os dados da newsletter:', error);
    if (globalErrorMessage) globalErrorMessage.classList.remove('hidden');
  })
  .finally(() => {
    if (submitButton) {
      submitButton.disabled = false;
      submitButton.style.opacity = '1';
      if (buttonText) buttonText.classList.remove('hidden');
      if (loadingSpinner) loadingSpinner.classList.add('hidden');
    }
  });
}

window.sendNewsletter = sendNewsletter;

